import React from 'react';
import { MenuButton } from '@headlessui/react';
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid';

export default function StackedListMenuToggle() {
  return (
    <MenuButton className="-m-2.5 block p-2.5 text-gray-400 hover:text-gray-50 cursor-pointer">
      <span className="sr-only">Open options</span>
      <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
    </MenuButton>
  );
}
